/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Paste_ButtonInputs */



/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Login_Offline_Paste_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_paste_button = /** @type {((inputs?: Login_Offline_Paste_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Paste_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Paste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impasto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ペースト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar")
	return /** @type {LocalizedString} */ ("Paste")
});